'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initUpsells = exports.init = exports.checkUpsells = exports.getInventories = exports.priceCache = exports.inventoryCache = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('slick-carousel');

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Helpers = require('../../common/Helpers');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inventoryCache = exports.inventoryCache = {};
var priceCache = exports.priceCache = {};

var getInventories = exports.getInventories = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(variantIdsArray) {
    var country, timeout, fetchRetry;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _Flow2.default.getCountry();

          case 2:
            country = _context.sent;

            // TODO: cleanup following 2 functions
            timeout = function timeout(promise, ms) {
              return new Promise(function (resolve, reject) {
                setTimeout(function () {
                  return reject(new Error('timeout'));
                }, ms);
                promise.then(resolve, reject);
              });
            };

            fetchRetry = function fetchRetry(url, retryCount) {
              return timeout(fetch(url), 2000).catch(function (error) {
                if (retryCount === 1) throw error;
                return fetchRetry(url, retryCount - 1);
              });
            };

            // change for test store


            _context.next = 7;
            return fetchRetry('https://closeapp.mvmtwatches.com/api/inventory?destination=' + country + '&ids=' + variantIdsArray.join(','), 3)
            // return fetchRetry(`https://closeapp-test.mvmtwatches.com/api/inventory?destination=${country}&ids=${variantIdsArray.join(',')}`, 3)
            .then(function (res) {
              return res.json();
            }).catch(function (error) {
              PubSub.publish(_Constants2.default.requestError, { error: error, type: 'Inventory' });
            });

          case 7:
            return _context.abrupt('return', _context.sent);

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getInventories(_x) {
    return _ref.apply(this, arguments);
  };
}();

// export const checkChildAvailability = async product => {
//   return new Promise(async resolve => {
//     const variantId = product.variants[0].id;

//     if (!inventoryCache.hasOwnProperty(variantId)) {
//       const json = await getInventories([ variantId ]);

//       if (json && json.inventory && json.inventory[0]) {
//         inventoryCache[json.inventory[0].variant_id] = json.inventory[0].available;
//       }
//     }

//     if (inventoryCache[variantId] <= 0) {
//       product.available = false;
//     }

//     resolve(product);
//   });
// };

// const checkInventoryAndPrices = async function (productHandles, variantIds) {
//   if (variantIds.length === 0) return;

//   const idHandles = {};
//   const newVariantIds = [];

//   variantIds.forEach((variantId, index) => {
//     if (!inventoryCache.hasOwnProperty(variantId)) {
//       newVariantIds.push(variantId);
//       idHandles[variantId] = productHandles[index];
//     }
//   });

//   if (newVariantIds.length !== 0) {
//     const json = await getInventories(newVariantIds);

//     if (json && json.inventory) {
//       json.inventory.forEach(inventory => {
//         inventoryCache[inventory.variant_id] = inventory.available;
//         // cachePrice(inventory, idHandles[inventory.variant_id]);
//       });
//     }
//   }

//   variantIds.forEach(variantId => {
//     if (inventoryCache.hasOwnProperty(variantId)) {
//       if (inventoryCache[variantId] <= 0) {
//         const element = $('[add-to-cart][data-variant-id="' + variantId + '"]');

//         element.parent().find('.collection-quickview-trigger').addClass('hidden');
//         const $productTag = element.closest('.product-grid-item').find('.product-tag').eq(0);

//         if ($productTag.length < 1 && !$productTag.hasClass('js-priority-tag')) {
//           element.closest('.product-grid-item').append('<span class="product-tag tag-red">SOLD OUT</span>');
//         } else if (!$productTag.hasClass('js-priority-tag')) {
//           $productTag
//             .text('SOLD OUT')
//             .addClass('tag-red')
//             .removeClass('tag-black')
//             .removeClass('tag-empty');
//           $productTag.css({ visibility: 'visible', width: 'unset', padding: '' });
//         }
//       }
//     } else {
//       console.error(`${variantId} not found in inventoryCache`);
//     }
//   });

// };

// const cachePrice = async (inventory, productHandle) => {
//   const flowExperience = window.Flow.getExperience() || 'usa';

//   priceCache[flowExperience] = priceCache[flowExperience] || {};
//   priceCache[flowExperience][inventory.warehouse] = priceCache[flowExperience][inventory.warehouse] || {};

//   const pricesHtml = priceCache[flowExperience][inventory.warehouse][inventory.variant_id]
//     ? priceCache[flowExperience][inventory.warehouse][inventory.variant_id]
//     : await getAlternativeTemplate(`products/${productHandle}/${inventory.variant_id},${inventory.warehouse}`, 'flow-price');

//   if (pricesHtml.indexOf('flow-localized') >= 0) {
//     $(`.product-grid-item[data-variant-id="${inventory.variant_id}"] .money-block`).replaceWith(pricesHtml);
//   }
//   priceCache[flowExperience][inventory.warehouse][inventory.variant_id] = pricesHtml;
//   // sessionStorage.setItem('priceCache', JSON.stringify(priceCache));
// };

// const checkRestricted = function (variantIds) {
//   if (!window.Flow || variantIds.length === 0) return;

//   const newVariantIds = [];

//   variantIds.forEach(variantId => {
//     const localizedVariant = window.Flow.cache.localizedVariants ? window.Flow.cache.localizedVariants.getById(variantId) : undefined;

//     if (localizedVariant) {
//       if (localizedVariant.status === 'excluded' || localizedVariant.status === 'restricted') {
//         $(`.product-grid-item[data-variant-id="${localizedVariant.id}"]`).hide();
//       }
//     } else {
//       newVariantIds.push(variantId);
//     }
//   });


//   if (newVariantIds.length !== 0) {
//     window.Flow.variants.load({
//       variants: newVariantIds,
//       experience: window.Flow.getExperience(),
//       success (response, variants) {
//         Object.keys(variants).forEach(variantId => {
//           const localizedVariant = variants[variantId];

//           if (localizedVariant.status === 'excluded' || localizedVariant.status === 'restricted') {
//             $(`.product-grid-item[data-variant-id="${localizedVariant.id}"]`).hide();
//           }
//         });
//       },
//     });
//   }
// };

var checkUpsells = exports.checkUpsells = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var variantIds, newVariantIds, json;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            variantIds = [];
            newVariantIds = [];


            $('[data-upsell-checkbox]').each(function (index, element) {
              var variantId = parseInt(element.value);

              if (variantId) {
                variantIds.push(variantId);
                if (!inventoryCache.hasOwnProperty(variantId)) {
                  newVariantIds.push(variantId);
                }
              }
            });

            if (!(newVariantIds.length !== 0)) {
              _context2.next = 8;
              break;
            }

            _context2.next = 6;
            return getInventories(newVariantIds);

          case 6:
            json = _context2.sent;


            if (json && json.inventory) {
              json.inventory.forEach(function (inventory) {
                inventoryCache[inventory.variant_id] = inventory.available;
              });
            }

          case 8:

            $(_Dom2.default.pdpUpsells + '.slick-slider').slick('slickFilter', function (index, element) {
              var checkbox = $(element).find('[data-upsell-checkbox]')[0];

              if (checkbox) {
                var variantId = parseInt(checkbox.value);

                if (inventoryCache.hasOwnProperty(variantId)) {
                  if (inventoryCache[variantId] <= 0) {
                    return false;
                  }
                } else {
                  console.error(variantId + ' not found in inventoryCache');
                }
              }
              return true;
            });

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function checkUpsells() {
    return _ref2.apply(this, arguments);
  };
}();

// $(dom.pdpUpsells).on('init reInit afterChange', (event, slick) => {
//   console.log('1');
//   if (slick.slideCount === 0) {
//     $(dom.pdpUpsellsWrapper).css('display', 'none');
//     console.log('2');
//   } else {
//     $(dom.pdpUpsellsWrapper).css('display', 'block');
//     console.log('3');
//   }
// });

// export const checkProductGridItems = async () => {
//   const variantIds = [];
//   const productHandles = [];

//   $('[add-to-cart]').each((index, element) => {
//     const variantId = parseInt(element.dataset.variantId);
//     const productHandle = element.dataset.productHandle;

//     if (productHandle && variantId) {
//       variantIds.push(variantId);
//       productHandles.push(productHandle);
//     }
//   });

//   checkInventoryAndPrices(productHandles, variantIds);
//   checkRestricted(variantIds);
// };

var init = exports.init = function init() {};

var initUpsells = exports.initUpsells = function initUpsells() {
  if (window.Flow && window.Flow.getExperience && window.Flow.getCountry) {
    // checkUpsells();
    return;
  }

  window.Flow.set('on', 'ready', function () {
    // checkUpsells();
  });
};

exports.default = {
  init: init,
  initUpsells: initUpsells,
  inventoryCache: inventoryCache,
  priceCache: priceCache,
  getInventories: getInventories,
  // checkChildAvailability,
  checkUpsells: checkUpsells
  // checkProductGridItems,
};